/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/no-unused-vars */
import { Component, forwardRef, HostBinding, Input, OnDestroy, OnInit } from '@angular/core'
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms'
import { Observable, Subject } from 'rxjs'
import { switchMap, takeUntil, tap } from 'rxjs/operators'
import { coerceBooleanProperty } from '@angular/cdk/coercion'
import { Validators } from '@angular/forms'

@Component({
  selector: 'lin-autocomplete-field',
  templateUrl: './autocomplete-field.component.html',
  styles: [
    `
      .autocomplete-field {
        width: 100%;
      }
      .placeholder {
        color: var(--main-gray-color);
      }
    `,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteFieldComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class AutocompleteFieldComponent implements ControlValueAccessor, OnInit, OnDestroy {
  @HostBinding('class.g-disabled')
  @Input()
  set disabled(value) {
    this._disabled = coerceBooleanProperty(value)
  }
  get disabled() {
    return this._disabled
  }

  control = new FormControl()
  isAutocompleteLoading = false
  selectedOption = null
  autocompleteOptions = []

  @Input() autocompleteRequest: (value: string) => Observable<any>
  @Input() displayWith: (value: any) => string
  @Input() required: boolean

  private readonly onDestroy$ = new Subject<void>()
  private _disabled: boolean

  ngOnInit() {
    this.initControlHandler()
  }

  initControlHandler() {
    this.control.valueChanges
      .pipe(
        tap(() => (this.isAutocompleteLoading = true)),
        switchMap(this.autocompleteRequest),
        tap(() => (this.isAutocompleteLoading = false)),
        takeUntil(this.onDestroy$),
      )
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-return
      .subscribe((autocompleteOptions) => (this.autocompleteOptions = autocompleteOptions))

    this.required && this.control.addValidators(Validators.required)
  }

  writeValue(obj: any): void {
    this.control.setValue(obj)
  }

  registerOnChange(fn: any): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return
    this.control.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((value) => fn(value))
  }

  registerOnTouched(fn: any): void {
    // registerOnTouched
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
